import React from 'react'
import "./project.css";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

function BasicExample({title, image, read}) {
  return (
    <Card className= "card" >
      <Card.Img variant="top" style={{ height: "70%", objectFit: 'cover' }} src={image} />
      <Card.Body style={{marginTop: 'auto'}}>
        <Card.Title style={{ marginTop: 'auto' }}>{title}</Card.Title>
        
        {/* <Button style= {{marginBottom:"10px", marginTop:"10px"}} variant="primary" href= {read}>Learn More</Button> */}
      </Card.Body>
    </Card>
  );
}

export default function Project() {
    const cardData = [
        {
            title: 'Electrical Insulation Coating.',
            image: 'https://5.imimg.com/data5/SELLER/Default/2023/11/364087978/OA/PQ/OB/11456638/breakdown-voltage-epoxy-flooring-service-1000x1000.jpg',
            read: "https://www.youtube.com/watch?v=se9WMfsiIF0",
        },
        {
            title: 'Heat Reflective Coating and Paint.',
           image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQb-FNSxG1iVynzU6VPFbQAzXkR09sKXqwPbg&s',
           read: "https://www.youtube.com/watch?v=se9WMfsiIF0",
        },
        {
            title: 'High End Industrial Flooring.',
            image: 'https://www.protexion.in/image/products/epoxy-flooring11.jpeg',
            read: "www.google.com",
        },
        {
            title: 'Antiskid Car Parking Flooring.',
            image: 'https://th.bing.com/th/id/OIP.mWIAaJauTkFvooYfCk1p_gHaEb?w=263&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7',
            read: "www.google.com",
        },{
            title: 'Anti-Corrosive Protective Coating.',
            image: 'https://www.tiger-coatings.com/fileadmin/user_upload/content/Blog_NA/Corrosion_Protection_Coating.jpg',
            read: "www.google.com",
          },{
            title: 'Waterproofing.',
            image: 'https://lh3.googleusercontent.com/proxy/D5ScyKpa_q5YUYcCWWtBiXn8J1aTk_3x3Bz0fmkRjw4d_KF0LLMLrsTDc8E6WI6cPrO2oWEx2uHtQYAMU7LUp7o-Qt7rwzovLXWkYKSKxKJNXYgVhtBpGFYpuqL66wtkPMvxBxUvjQgH',
            read: "www.google.com",
          },
    ]
  return (
    <div className='projects'>
      <h1 >Our Projects</h1>
      <div className = "card-container">
        {cardData.map((card, index) => (
          <BasicExample 
            key={index}
            title={card.title}
            text={card.text}
            image={card.image}
            read = {card.read}
          />
        ))}
      </div>
    </div>
  );
}
